module.exports = __webpack_public_path__ + "static/media/facebook-icon-blue.cbb9b56a.svg";